import type { DetailedPlayerType } from "@/pages/DetailedPlayer/DetailedPlayer";
import type { MetaRatingsPlayer } from "@/redux/players/playersSlice";

import type { EvolutionBuilderPlayer } from "./evolutionsBuilderSlice";

/**
 * Type-only imports on purpose: this file is a test seam. A runtime import of
 * the slice or api modules drags the axios setup into vitest.
 */
export const convertToEvolutionBuilderPlayer = (
  payload: (DetailedPlayerType | MetaRatingsPlayer | EvolutionBuilderPlayer) & {
    cardName?: string;
  },
): EvolutionBuilderPlayer =>
  ({
    ...payload,
    // Squad-builder players carry cardName instead of name, and the details URL
    // reads name, so fill it in or the URL loses its name segment.
    name: payload.name ?? payload.cardName ?? "",
    sbcStorage: false,
    eaPlayerId: undefined,
    positions: payload.possiblePositions,
    untradeable: false,
    isSbcPlayer: "isSbc" in payload && payload.isSbc,
    isObjectivePlayer: "isObjective" in payload && payload.isObjective,
    metaRating: payload.metaRating,
  }) as EvolutionBuilderPlayer;
